import LiveEvent from '../interface/LiveEvent'
import Cell, { RowsCell, ColumnValue, CellFormatter } from './Cell'

import addInTree from './addInTree'
import setValue from './setValue'
import methods from './methods'

export default function toTreeData(
    batch: LiveEvent[],
    rowsGroup: string[] = [],
    columsGroup: string[],
    valuesGroup: string[],
    specials: string[],
    showTotal: boolean = false
) {
    let columns: Array<object> = []
    let rows: Array<object> = []
    let prevColumn: any
    let modifier: object = { enable: false }

    const FIRST_ROW = 'firstRow'

    const eventRow = {
        [FIRST_ROW]: '' // rowsGroup.join(" / "),
    }

    const resolveColumns = ({ isRoot, isLeaf, tree, value }) => {
        const [key, arr] = isRoot ? [`${tree.length}`, tree] : [`${tree.key}-${tree.children.length}`, tree.children]

        let parent = arr.find(({ title }: { title: string }) => title === value)

        if (!parent) {
            parent = Cell.newColumnsCell(value, key, tree.length == 0)
            arr.push(parent)
        }

        return parent
    }

    const resolveRows = ({ isRoot, isLeaf, tree, value, event, modifier, dataIndex, itemPosition }) => {
        const fnd = (arr: RowsCell[], value: string) =>
            arr.find(r => {
                const cell = r.get('0') as ColumnValue
                return cell.value == value
            })

        const [arr] = (() => {
            if (isRoot) {
                return [tree] // se for o nó raiz, pega o  array principal
            }
            if (!tree.children) {
                tree.set('children', [])
            }
            return [tree.children]
        })()

        let parent = fnd(arr, value) // procura nos filhos do pai se ele existe,

        if (!parent) {

            const cellKey = `${tree.id ?? ''}-${itemPosition}-${arr.length}`
            parent = Cell.newRowsCell(value, tree, cellKey)
            arr.push(parent)
        }
        
        valuesGroup.forEach(valueIndex => {
            const { __format = {}, __methods } = modifier
            const isFormat = !!__format[dataIndex]

            let method = methods.sum

            if (isFormat) {
                method = methods.formated
            }

            if (__methods && !!__methods[dataIndex]) {
                method = __methods[dataIndex]
            }

            setValue({
                parent: tree,
                children: parent,
                column: prevColumn.key,
                isRoot,
                method: method,
                dataIndex,
                valueIndex,
                event,
                modifier,
                isLeaf,
                key: parent.id
            })
        })
        
        return parent
    }
    
    const setColumns = ({ tree, childrens, isRoot, isLeaf }) => {
        if (isRoot) {
            columns = tree
        }
        if (isLeaf) {
            prevColumn = childrens
        }
    }

    const setRows = ({ tree, isRoot, isLeaf }) => {
        if (isRoot) {
            rows = tree
        }
    }

    //ADD COLUMN TO ROW
    if (rowsGroup.length > 0) addInTree(eventRow, columns, [FIRST_ROW], resolveColumns, setColumns, {})

    batch.map((event: any) => {
        prevColumn = null

        if (
            specials &&
            specials
                .reduce((t, e) => {
                    return [...t, event[e] ? true : false]
                }, [])
                .indexOf(true) > -1
        )
            modifier = specials.reduce((t, e, i) => {
                return {
                    ...t,
                    [e]: {
                        enable: true,
                        ...event[e],
                        ...columsGroup.reduce((t, e, i) => {
                            return { ...t, column: event[e] }
                        }, {})
                    }
                }
            }, {})

        addInTree(event, columns, columsGroup, resolveColumns, setColumns, modifier)

        if (prevColumn) {
            addInTree(event, rows, rowsGroup, resolveRows, setRows, modifier)
        }
    })

    // Add total row
    // if (showTotal)
    // rows.push(
    //   columns.reduce((row: any, column, indexColumn) => {
    //     if (indexColumn === 0) row.children = [];
    //     else {
    //       let calculated = rows.reduce(
    //         (partial: { value: number; method: string, formatter: CellFormatter }, cur) => {
    //           return {
    //             value: partial.value + cur[indexColumn].value,
    //             method: cur[indexColumn].method,
    //             formatter: cur[indexColumn].formatter
    //           };
    //         },
    //         { value: 0,
    //           method: "",
    //           formatter: {} as CellFormatter }
    //       ) as { value: number; method: string, formatter: CellFormatter };

    //       // Made possible to choose between sum and avg
    //       let calculatedValue: number;

    //       switch (calculated.method) {
    //         case methods.avg:
    //           const countChildren = rows.length;
    //           calculatedValue =
    //             Math.round((calculated.value / countChildren) * 100) / 100;
    //           break;

    //         case methods.sum:
    //           calculatedValue = Math.round(calculated.value * 100) / 100;
    //           break;

    //         default:
    //           break;
    //       }

    //       row[indexColumn] = Cell.newCellValue({
    //         value: calculatedValue,
    //         method: calculated.method,
    //         parent: null,
    //         color: calculated?.formatter?.color,
    //         suffix: calculated?.formatter?.suffix,
    //         prefix: calculated?.formatter?.prefix,
    //       });
    //     }

    //     return row;
    //   }, Cell.newRowsCell("Total", null))
    // );

    return [columns, rows]
}
